import React, { useState, useEffect } from 'react';
import { StyleSheet, View, Platform } from 'react-native';

import { useTheme } from '@emotion/react';
import getScreenType from '../../../../utils/getScreenType';
import { ODSIcon } from '../../../atoms/ODSIcon';
import { ODSText } from '../../../atoms/ODSText';
import ODSTabs from '../../../atoms/ODSTabs';


const MyInvoiceCard = (props) => {
  const { colors } = useTheme();
  const [selectedIndex, setSelectedIndex] = useState(1);

  // Force re-render when tab changes to ensure data refresh
  useEffect(() => {
    // This will trigger a re-render when selectedIndex changes
  }, [selectedIndex]);

  return (
    <View style={{ flex: 1, ...styles.shadowBox }}>
      <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', marginBottom: 32 }}>
        <ODSIcon icon={'TB-Book'} size={24} color={colors.button.main} />
        <ODSText type='h5' color={colors.text.primary} marginLeft={12} marginTop={0}>{`My Invoices,\nSubscriptions & Orders`}</ODSText>
      </View>
      <ODSTabs
        items={['Invoices', 'My Subscriptions', 'Orders']}
        selectedColor={colors.main.blue[700]}
        color={colors.main.blue[500]}
        activeTab={selectedIndex}
        onTabChange={(val) => setSelectedIndex(val)}
        restStyle={{
          // minHeight: 50,
          marginBottom: 20,
        }}
      />
      {selectedIndex == 1 ?
        <React.Fragment key={`subscription-tab-${selectedIndex}`}>
          {props?.subscriptionList}
        </React.Fragment> :
        <React.Fragment key={`invoice-tab-${selectedIndex}`}>
          {props?.invoiceList}
        </React.Fragment>

      }
      {/* {props.children} */}
    </View>
  );
};
const styles = StyleSheet.create({
  shadowBox: {
    backgroundColor: '#fff',
    marginHorizontal: 20,
    paddingVertical: 32,
    paddingHorizontal: 20,
    borderRadius: 12,
    ...Platform.select({
      ios: {
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 3 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
      },
      android: {
        elevation: 4,
      },
      web: {
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 3 },
        shadowOpacity: 0.15,
        shadowRadius: 8,
      }
    }),
  },
});


export default MyInvoiceCard;
